/*
 * Cordial-IA 2026-10-11 - En-tete et menu "G" (sections/cordial-header.liquid).
 * Panneaux : ouverture au survol et au clic, fermeture a Echap, au clic dehors et quand le focus
 * sort ; aria-expanded tenu a jour ; images des panneaux chargees a la premiere ouverture.
 * Mobile : feuille plein ecran, accordeon, verrou du defilement, retour du focus au bouton.
 * Panier : la bulle suit l'evenement 'wetheme-cart-update' (re-emis par cordial-cart-count.js
 * pour tous les flux cordial) ; le clic sur l'icone ouvre le tiroir via l'eventBus du theme.
 * Aucun commentaire en fin de ligne.
 */
(() => {
  const wrap = document.querySelector('[data-cordial-header]');
  if (!wrap || wrap.dataset.ready) return;
  wrap.dataset.ready = '1';
  const bar = wrap.querySelector('.chh');
  const sheet = wrap.querySelector('.chh-sheet');
  const burger = wrap.querySelector('.chh-burger');
  const section = wrap.closest('.shopify-section') || wrap;
  const mqDesktop = matchMedia('(min-width: 1100px)');
  const $$ = (s, r) => [...(r || wrap).querySelectorAll(s)];

  /* hauteur de la barre : variables pour la feuille mobile et pour le theme (ancres, barre collante) */
  const measure = () => {
    const r = bar.getBoundingClientRect();
    const root = document.documentElement.style;
    root.setProperty('--chh-h', Math.round(r.height) + 'px');
    root.setProperty('--chh-bottom', Math.round(r.bottom) + 'px');
    const h = Math.round(r.height) + 'px';
    root.setProperty('--header-height-desktop', h);
    root.setProperty('--header-height-mobile', h);
    root.setProperty('--sticky-header-desktop-height', h);
    root.setProperty('--sticky-header-mobile-height', h);
  };
  measure();
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);
  const onScroll = () => { document.documentElement.classList.toggle('chh-scrolled', scrollY > 8); if (sheet && !sheet.hidden) measure(); };
  onScroll();
  addEventListener('scroll', onScroll, { passive: true });

  /* images differees : chargees a la premiere ouverture d'un panneau ou d'un volet */
  const load = (root) => {
    $$('img[data-src]', root).forEach((im) => {
      im.src = im.dataset.src;
      im.removeAttribute('data-src');
      if (im.dataset.fallback) {
        im.addEventListener('error', () => { if (im.src !== im.dataset.fallback) im.src = im.dataset.fallback; }, { once: true });
      }
    });
  };

  /* ---------------------------------------------------------------- panneaux (ordinateur) */
  const items = $$('.chh-it[data-panel]');
  const setOpen = (it, open) => {
    const btn = it.querySelector('.chh-top');
    if (open) {
      items.forEach((o) => { if (o !== it) setOpen(o, false); });
      load(it);
    }
    it.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  const closeAll = () => items.forEach((it) => setOpen(it, false));
  items.forEach((it) => {
    const btn = it.querySelector('.chh-top');
    let t;
    it.addEventListener('mouseenter', () => { if (!mqDesktop.matches) return; clearTimeout(t); setOpen(it, true); });
    it.addEventListener('mouseleave', () => { if (!mqDesktop.matches) return; t = setTimeout(() => setOpen(it, false), 180); });
    btn.addEventListener('click', () => { clearTimeout(t); setOpen(it, !it.classList.contains('is-open')); });
    it.addEventListener('focusout', (e) => { if (!it.contains(e.relatedTarget)) setOpen(it, false); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.chh-it')) closeAll(); });

  /* ---------------------------------------------------------------- feuille mobile */
  let lastFocus = null;
  const setSheet = (open) => {
    if (!sheet || !burger) return;
    if (open) {
      lastFocus = document.activeElement;
      measure();
      sheet.hidden = false;
      load(sheet);
      requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('is-open')));
      document.documentElement.classList.add('chh-open');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', burger.dataset.closeLabel || 'Fermer le menu');
      const first = sheet.querySelector('.chh-row');
      if (first) setTimeout(() => first.focus({ preventScroll: true }), 460);
    } else {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('chh-open');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', burger.dataset.openLabel || 'Ouvrir le menu');
      const done = () => { if (!sheet.classList.contains('is-open')) sheet.hidden = true; };
      sheet.addEventListener('transitionend', done, { once: true });
      setTimeout(done, 500);
      if (lastFocus && sheet.contains(document.activeElement)) burger.focus();
    }
  };
  if (burger) burger.addEventListener('click', () => setSheet(burger.getAttribute('aria-expanded') !== 'true'));
  if (sheet) {
    $$('button.chh-row', sheet).forEach((row) => row.addEventListener('click', () => {
      const li = row.parentElement;
      const open = !li.classList.contains('is-open');
      li.classList.toggle('is-open', open);
      row.setAttribute('aria-expanded', open ? 'true' : 'false');
    }));
    /* garder le focus dans la feuille (menu modal) */
    sheet.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const f = $$('a[href], button:not([disabled])', sheet).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); burger.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); burger.focus(); }
    });
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeAll(); if (burger && burger.getAttribute('aria-expanded') === 'true') setSheet(false); } });
  mqDesktop.addEventListener('change', () => { closeAll(); setSheet(false); });

  /* ---------------------------------------------------------------- panier */
  const cartLink = wrap.querySelector('[data-chh-cart]');
  const bubble = wrap.querySelector('.chh-b');
  if (cartLink && wrap.dataset.cartDrawer === 'true') {
    cartLink.addEventListener('click', (e) => {
      if (!window.eventBus || typeof window.eventBus.emit !== 'function') return;
      e.preventDefault();
      closeAll();
      setSheet(false);
      window.eventBus.emit('open:cart:drawer', { scrollToTop: false });
    });
  }
  const setCount = (n) => {
    if (!bubble) return;
    const before = bubble.textContent.trim();
    bubble.textContent = n;
    bubble.classList.toggle('hide', !(n > 0));
    if (String(n) !== before && n > 0) {
      bubble.classList.remove('is-pulse');
      void bubble.offsetWidth;
      bubble.classList.add('is-pulse');
    }
  };
  document.documentElement.addEventListener('wetheme-cart-update', (e) => {
    const c = e.detail && e.detail.cart;
    if (c && typeof c.item_count === 'number') setCount(c.item_count);
  });
  if (window.eventBus && typeof window.eventBus.on === 'function') {
    window.eventBus.on('drawer:opened', (d) => { if (cartLink && d && d.tagName === 'CART-DRAWER') cartLink.setAttribute('aria-expanded', 'true'); });
    window.eventBus.on('drawer:closed', (d) => { if (cartLink && d && d.tagName === 'CART-DRAWER') cartLink.setAttribute('aria-expanded', 'false'); });
  }
  section.dataset.chhReady = '1';
})();
